import { Col, Row, Select, Space, Table, Typography } from "antd";
import { SearchInput } from "components/Shared/SearchInput";
import { SeasonStatuses } from "enums/seasonStatuses";
import { useEnumDropdown } from "hooks/useEnumDropdown";
import { useState } from "react";
import { useIntl } from "react-intl";

const DefaultStatusOptionValue = "DEFAULT";

type Props = {
  title?: string;
  isLoading: boolean;
  seasons: Array<any>;
  columns: Array<any>;
};

export const SeasonTable = ({ title, isLoading, seasons, columns }: Props) => {
  const { formatMessage } = useIntl();
  const [currentStatus, setCurrentStatus] = useState("DEFAULT");
  const [searchText, setSearchText] = useState("");
  const defaultOption = {
    label: formatMessage({ id: "select.seasonStatus.defaultOption.label" }),
    value: DefaultStatusOptionValue,
  };
  const dropDownStatuses = useEnumDropdown(SeasonStatuses, "seasonStatus", false);
  const options = [defaultOption, ...dropDownStatuses];

  const filteredSeasons = seasons
    ?.filter((x) =>
      currentStatus === DefaultStatusOptionValue
        ? x?.status === SeasonStatuses.ACTIVE || x?.status === SeasonStatuses.PENDING
        : x?.status === currentStatus
    )
    ?.filter(
      (season) =>
        season?.nameLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 ||
        season?.competitionNameLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 ||
        season?.year?.toString()?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1
    );

  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={5}>{title ?? "\u00A0"}</Typography.Title>
        <Space align="center">
          <Select
            popupMatchSelectWidth={false}
            variant="borderless"
            defaultValue={DefaultStatusOptionValue}
            onChange={setCurrentStatus}
            options={options}
          />
          <SearchInput onSearch={setSearchText} />
        </Space>
      </Row>
      <Row className="mb-15">
        <Col span={24}>
          <Table
            size="small"
            loading={isLoading}
            dataSource={filteredSeasons}
            rowKey="seasonId"
            columns={columns as any}
            pagination={false}
          />
        </Col>
      </Row>
    </>
  );
};
